import { clsx } from "clsx";
import type { FC } from "react";

import style from "./styles/Form.module.scss";

export interface FormInputGroupProps {
  horizontalLayout?: boolean;
  children: React.ReactNode;
  style?: any;
}

const FormInputGroup: FC<FormInputGroupProps> = (props) => {
  const classes = clsx(style.form_group, { [style.horizontal_form_group]: props.horizontalLayout });

  return (
    <div className={classes} style={props.style} data-testid={"form-group"}>
      {props.children}
    </div>
  );
};

export { FormInputGroup };
